// extracted by mini-css-extract-plugin
export default {"ButtonBlock":"ButtonBlockBgrsg","buttonBlock":"ButtonBlockBgrsg"};